export const BASKET_REDUCER_KEY = 'basket';
